import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropBookingsByCustomerId } from '~/navigation/Navigation.types';

import { BookingItem } from '../BookingItem';
import { BookingList, BookingListNative } from '../Bookings.List';

export const BookingsByCustomerIdScreen = (props: ScreenPropBookingsByCustomerId) => {
  return (
    <PageContainer>
      <BookingsLayout {...props} />
    </PageContainer>
  );
};

export const BookingsLayout = (props: ScreenPropBookingsByCustomerId) => {
  const bookingId = props.route.params?.id;
  const customerId = props.route.params?.customerId;

  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(bookingId);
  }, [bookingId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <BookingList onPress={(item) => setId(item.id)} customerId={customerId} />
      ) : (
        <BookingListNative customerId={customerId} />
      )}
      {id ? <BookingItem bookingId={id} onClose={() => setId(undefined)} /> : <></>}
    </ScreenTwoPageLayout>
  );
};
